$(document).ready(function() {
  
    $('.btn-menu').on('click', function() {
        $('.line-1').toggleClass('mv--translate-y-1.5 mv-rotate-45');
        $('.line-2').toggleClass('mv-opacity-0');
        $('.line-3').toggleClass('mv-translate-y-1.5 mv--rotate-45');
        $('.mobile-nav').toggleClass('active').animate({scrollTop: 0});
        $('.mobile-country-icons-list').addClass('hidden').removeClass('shown');
        $('body').toggleClass('mobile-nav-active');
    });

    $('.mobile-nav .has-sub>a').on('click', function(e) {
        e.preventDefault();
        $(this).parent().toggleClass('active');
        $(this).next().toggleClass('mv-hidden');
        $(this).children().toggleClass('mv-hidden');
    });

    $('.tabs>li>a').on('mouseover', function(e) {
        e.preventDefault();
        var tab_id = $(this).attr('data-tab');
        $(this).parent().addClass('active').siblings().removeClass('active');
        $('#'+tab_id).addClass('active').siblings().removeClass('active');
    });
  
    $('.product-tabs li').on('click', function() {
        var tab_id = $(this).attr('data-tab');
        $(this).addClass('active').siblings().removeClass('active');
        $('#'+tab_id).addClass('active').siblings().removeClass('active');
    });

    function swiper() {
    	const hero = new Swiper('.swiper-hero', {
		    slidesPerView: 1,
		    autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            centeredSlides: true,
		    loop: true,
		    init: window.innerWidth >= 768 ? false : true
	    });
        const quotes = new Swiper('.swiper-quotes', {
            slidesPerView: 1,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false
            },
            centeredSlides: true,
            loop: true
        });
        const healthquotes = new Swiper('.swiper-healthquotes', {
            slidesPerView: 1,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false
            },
            centeredSlides: true,
            loop: true
        });
        const reviews = new Swiper('.swiper-reviews', {
            slidesPerView: 1,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
        });
        const healthreviews = new Swiper('.swiper-healthreviews', {
            slidesPerView: 1,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            autoplay: {
              delay: 10000,
              disableOnInteraction: false
            },
            speed: 1000
        });
        const erecommendedbyquotes = new Swiper('.swiper-recommendedby-quotes', {
            slidesPerView: 1,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            autoplay: {
              delay: 10000,
              disableOnInteraction: false
            },
            speed: 1000
        });
        const featuredinlogos = new Swiper('.swiper-featuredin-logos', {
            slidesPerView: 1,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            autoplay: {
              delay: 10000,
              disableOnInteraction: false
            },
            speed: 1000
        });
        const blog = new Swiper('.swiper-blog', {
            slidesPerView: 1.2,
            spaceBetween: 12,
            loop: true,
            freeMode: true,
            mousewheel: {
                forceToAxis: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.5,
                },
                981: {
                    slidesPerView: 3.5,
                },
                1200: {
                    slidesPerView: 3.7,
                },
            },
        });
        const health = new Swiper('.swiper-health', {
          spaceBetween: 20,
          slidesPerView: 1.3,
          centerInsufficientSlides: true,
          grabCursor: true,
          mousewheel: {
              forceToAxis: true,
              releaseOnEdges: true,
              thresholdDelta: 1,
              thresholdTime: 10
          },
          keyboard: {
              enabled: true,
			  onlyInViewport: true	
          },
          pagination: {
            el: '.sw-pagination-health',
            clickable: true
          },
          breakpoints: {
            1100: {
              spaceBetween: 40,
              slidesPerView: 3.5
            },
            990: {
              spaceBetween: 30,
              slidesPerView: 3.5
            },
            800: {
              spaceBetween: 20,
              slidesPerView: 2.5
            }
          }
      });
      const healthfunctions = new Swiper('.swiper-healthfunctions', {
          spaceBetween: 20,
          slidesPerView: 'auto',
          centerInsufficientSlides: true,
          grabCursor: true,
          mousewheel: {
              forceToAxis: true,
              releaseOnEdges: true,
              thresholdDelta: 1,
              thresholdTime: 10
          },
          keyboard: {
              enabled: true,
			  onlyInViewport: true	
          },
          pagination: {
            el: '.sw-pagination-healthfunctions',
            clickable: true
          }
      });
      const usecasecards = new Swiper('.swiper-usecase-cards', {
          spaceBetween: 20,
          slidesPerView: 'auto',
          centerInsufficientSlides: true,
          grabCursor: true,
          mousewheel: {
              forceToAxis: true,
              releaseOnEdges: true,
              thresholdDelta: 1,
              thresholdTime: 10
          },
          keyboard: {
              enabled: true,
			  onlyInViewport: true	
          }
      });
      const journals = new Swiper('.swiper-journals', {
          spaceBetween: 20,
          slidesPerView: 'auto',
          centerInsufficientSlides: true,
          grabCursor: true,
          mousewheel: {
              forceToAxis: true,
              releaseOnEdges: true,
              thresholdDelta: 1,
              thresholdTime: 10
          },
          keyboard: {
              enabled: true,
			  onlyInViewport: true	
          },
          pagination: {
            el: '.sw-pagination-journals',
            clickable: true
          }
      });
      const accessories = new Swiper('.swiper-accessories', {
          spaceBetween: 20,
          slidesPerView: 1.1,
          centerInsufficientSlides: false,
          grabCursor: true,
          breakpoints: {
            500: {
              spaceBetween: 20,
              slidesPerView: 'auto',
            },
          },
          mousewheel: {
              forceToAxis: true,
              releaseOnEdges: true,
              thresholdDelta: 1,
              thresholdTime: 10
          },
          keyboard: {
              enabled: true,
			  onlyInViewport: true	
          },
          pagination: {
            el: '.sw-pagination-accessories',
            clickable: true
          }
      });
      
      const swiperhomepagebanner = new Swiper('.swiper-homepage-banner', {
          spaceBetween: 15,
          slidesPerView: 1.1,
          grabCursor: true,
          autoHeight: false,
          breakpoints: {
            500: {
              spaceBetween: 20,
              slidesPerView: 'auto',
            },
          },
          mousewheel: {
              forceToAxis: true,
              releaseOnEdges: true,
              thresholdDelta: 1,
              thresholdTime: 10
          },
          keyboard: {
              enabled: true,
			  onlyInViewport: true	
          }
      });


      const swiperhomepagedevices = new Swiper('.swiper-homepage-devices', {
          spaceBetween: 20,
          slidesPerView: 1,
          grabCursor: false,
          autoHeight: false,
          breakpoints: {
            620: {
              spaceBetween: 20,
              slidesPerView: 1.5,
              grabCursor: true,
            },
            830: {
              spaceBetween: 20,
              slidesPerView: 2,
              grabCursor: true,
            },
          },
          mousewheel: {
              forceToAxis: true,
              releaseOnEdges: true,
              thresholdDelta: 1,
              thresholdTime: 10
          },
          keyboard: {
              enabled: true,
			  onlyInViewport: true	
          }
      });
      

      const trustbar = new Swiper('.swiper-trust-bar', {
          spaceBetween: 0,
          slidesPerView: 'auto',
          grabCursor: true,
          mousewheel: {
              forceToAxis: true,
              releaseOnEdges: true,
              thresholdDelta: 1,
              thresholdTime: 10
          },
          keyboard: {
              enabled: true,
			  onlyInViewport: true	
          },
          pagination: {
            el: '.sw-pagination-trust-bar',
            clickable: true
          }
      });
      const recommendedbyquotes = new Swiper('.swiper-recommended-by-quotes', {
          spaceBetween: 20,
          slidesPerView: 'auto',
          centerInsufficientSlides: true,
          grabCursor: true,
          mousewheel: {
              forceToAxis: true,
              releaseOnEdges: true,
              thresholdDelta: 1,
              thresholdTime: 10
          },
          keyboard: {
              enabled: true,
			  onlyInViewport: true	
          },
          pagination: {
            el: '.sw-pagination-recommended-by-quotes',
            clickable: true
          }
      });
      const presslogosrow = new Swiper('.swiper-press-logos-row', {
          spaceBetween: 0,
          slidesPerView: 'auto',
          grabCursor: true,
          breakpoints: {
            800: {
              spaceBetween: 0,
              slidesPerView: 'auto'
            },
          },
          mousewheel: {
              forceToAxis: true,
              releaseOnEdges: true,
              thresholdDelta: 1,
              thresholdTime: 10
          },
          keyboard: {
              enabled: true,
			  onlyInViewport: true	
          },
          pagination: {
            el: '.sw-pagination-press-logos-row',
            clickable: true
          }
      });
      const recommendedbylogosrow = new Swiper('.swiper-recommended-by-logos-row', {
          spaceBetween: 0,
          slidesPerView: 3,
          //centeredSlides: true,
          //centeredSlidesBounds: true,
          grabCursor: true,
          breakpoints: {
            600: {
              spaceBetween: 0,
              slidesPerView: 'auto'
            },
          },
          mousewheel: {
              forceToAxis: true,
              releaseOnEdges: true,
              thresholdDelta: 1,
              thresholdTime: 10
          },
          keyboard: {
              enabled: true,
			  onlyInViewport: true	
          },
          pagination: {
            el: '.sw-pagination-recommended-by-logos-row',
            clickable: true
          }
      });
      
      const remote_health = new Swiper('.swiper-remote-health', {
          spaceBetween: 20,
          slidesPerView: 1.3,
          centerInsufficientSlides: true,
          grabCursor: true,
          mousewheel: {
              forceToAxis: true,
              releaseOnEdges: true,
              thresholdDelta: 1,
              thresholdTime: 10
          },
          keyboard: {
              enabled: true,
			  onlyInViewport: true	
          },
          pagination: {
            el: '.sw-pagination-health',
            clickable: true
          },
          breakpoints: {
            990: {
              spaceBetween: 30,
              slidesPerView: 3.18
            },
            800: {
              spaceBetween: 20,
              slidesPerView: 2.18
            }
          }
      });
      const product_reviews = new Swiper('.swiper-product-reviews', {
        spaceBetween: 20,
        slidesPerView: 1.3,
        centeredSlides: true,
        loop: true,
        breakpoints: {
          1300: {
            spaceBetween: 40,
            slidesPerView: 2.7
          },
          800: {
            spaceBetween: 20,
            slidesPerView: 2.7
          },
          780: {
            spaceBetween: 20,
            slidesPerView: 1.3

          },
          420: {
            spaceBetween: 20,
            slidesPerView: 1.3
          }
        }
      });
      const tall_product_reviews = new Swiper('.swiper-tall-product-reviews', {
        spaceBetween: 20,
        slidesPerView: 1.3,
        centeredSlides: true,
        loop: true,
        breakpoints: {
          1300: {
            spaceBetween: 40,
            slidesPerView: 5.0
          },
          800: {
            spaceBetween: 20,
            slidesPerView: 3.7
          },
          780: {
            spaceBetween: 20,
            slidesPerView: 3.3

          },
          520: {
            spaceBetween: 20,
            slidesPerView: 3.0
          },
          420: {
            spaceBetween: 20,
            slidesPerView: 2.0
          }
        }
      });
      var testimonials = new Swiper('.swiper-testimonials', {
        slidesPerView: 1.2,
        spaceBetween: 0,
        centerMode: true,
        centerPadding: '30px',
        loop: true,
        breakpoints: {
          800: {
            slidesPerView: 1
          }
        }
      });
      const quote_cards = new Swiper('.swiper-quote-cards', {
          spaceBetween: 20,
          slidesPerView: 'auto',
          centerInsufficientSlides: true,
          grabCursor: true,
          mousewheel: {
              forceToAxis: true,
              releaseOnEdges: true,
              thresholdDelta: 1,
              thresholdTime: 10
          },
          keyboard: {
              enabled: true,
			  onlyInViewport: true	
          }
      }); 

      const expert_videos = new Swiper('.swiper-expert-videos', {
        spaceBetween: 20,
        slidesPerView: 1.3,
        centeredSlides: true,
        loop: true,
        autoHeight: false,
        breakpoints: {
          1300: {
            spaceBetween: 20,
            slidesPerView: 5.0
          },
          800: {
            spaceBetween: 20,
            slidesPerView: 3.7
          },
          780: {
            spaceBetween: 20,
            slidesPerView: 3.3

          },
          520: {
            spaceBetween: 20,
            slidesPerView: 3.0
          },
          420: {
            spaceBetween: 20,
            slidesPerView: 2.0
          }
        }
      });
    
      const expert_video_imgs = new Swiper('.swiper-expert-video-imgs', {
        spaceBetween: 10,
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        autoHeight: false
      });
      
      const collection = new Swiper('.swiper-collection', {
        slidesPerView: 1.2,
        spaceBetween: 12,
        centeredSlides: true,
        centeredSlidesBounds: true,
        breakpoints: {
          1100: {
            slidesPerView: 4,
            spaceBetween: 20,
			centeredSlides: false,
        	centeredSlidesBounds: false
          },
          780: {
            slidesPerView: 3,
            spaceBetween: 30
          },
          520: {
            slidesPerView: 2.2
          }
        }
      });
      const collection_three = new Swiper('.swiper-collection-three', {
        slidesPerView: 1.2,
        spaceBetween: 12,
        breakpoints: {
          1100: {
            slidesPerView: 4,
            spaceBetween: 40
          },
          780: {
            slidesPerView: 3,
            spaceBetween: 30
          },
          520: {
            slidesPerView: 2.2,
            centeredSlides: true,
            centeredSlidesBounds: true
          }
        }
      });
      const product_collection = new Swiper('.swiper-product-collection', {
        slidesPerView: 1.2,
        spaceBetween: 12,
        breakpoints: {
          640: {
            slidesPerView: 2.2,
            spaceBetween: 12
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 12
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 12
          }
        }
      });
      const playcards = new Swiper('.swiper-playcards', {
        spaceBetween: 15,
        slidesPerView: 1.5,
        centeredSlides: true,
        loop: true,
        grabCursor: true,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          thresholdDelta: 1,
          thresholdTime: 10
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true	
        },
        breakpoints: {
          1300: {
            slidesPerView: 4.5
          },
          900: {
            slidesPerView: 3.8
          },
          600: {
            slidesPerView: 2.3
          }
        }
      });
      
      const app = new Swiper('.swiper-app', {
        spaceBetween: 10,
        slidesPerView: 1.15,
        loop: true,
        grabCursor: true,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          thresholdDelta: 1,
          thresholdTime: 10
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true	
        },
        breakpoints: {
          1400: {
            slidesPerView: 5,
            spaceBetween: 15,
			loop: false
          },
          1200: {
            slidesPerView: 4.5,
            spaceBetween: 15
          },
          900: {
            slidesPerView: 3.2,
            spaceBetween: 15
          },
          700: {
            slidesPerView: 2.3,
            spaceBetween: 15
          },
          500: {
            slidesPerView: 1.4,
            spaceBetween: 10
          },
          400: {
            slidesPerView: 1.2,
            spaceBetween: 10
          }
        }
      });
      const shop = new Swiper('.swiper-shop', {
        slidesPerView: 1.2,
        spaceBetween: 16,
        breakpoints: {
          640: {
            slidesPerView: 2.2,
            spaceBetween: 16
          },
          768: {
            slidesPerView: 3.2,
            spaceBetween: 16
          }
        }
      });
      const collectionsliding = new Swiper('.swiper-collection-sliding', {
        spaceBetween: 16,
        slidesPerView: 'auto',
        grabCursor: true
      });
      const forxsliding = new Swiper('.swiper-forx-sliding', {
        spaceBetween: 16,
        slidesPerView: 'auto',
        grabCursor: true
      });
      const mobilenavsliding = new Swiper('.swiper-mobile-nav-sliding', {
        spaceBetween: 16,
        slidesPerView: 'auto',
        grabCursor: true
      });
      const bubblesbar = new Swiper('.swiper-bubblebar', {
        grabCursor: true,
        spaceBetween: 16,
        loop: false,
        breakpoints: {
          // For mobile views
          //300: {
          //  slidesPerView: 'auto',
          //  centeredSlides: true,
          //  initialSlide: 1
          //},
          300: {
            slidesPerView: 'auto',
            centeredSlides: false,
            initialSlide: 0,
            slidesOffsetBefore: 0
          },
          650: {
            slidesPerView: 'auto',
            centeredSlides: false,
            initialSlide: 0
          },
          // For desktop views
          1024: {
            slidesPerView: 'auto',
            centeredSlides: false,
            initialSlide: 0
          }
        }
      });
      /*const bubblesbar = new Swiper('.swiper-bubblebar', {
        grabCursor: true,
        slidesPerView: 1.5,
        spaceBetween: 0,
        centeredSlides: true,
        initialSlide: 1,
        loop: false,
        breakpoints: {
          300: {
            slidesPerView: 2.1,
            spaceBetween: 16
          },
          340: {
            slidesPerView: 2.2,
            spaceBetween: 16
          },
          360: {
            slidesPerView: 2.3,
            spaceBetween: 16
          },
          380: {
            slidesPerView: 2.5,
            spaceBetween: 16
          },
          400: {
            slidesPerView: 2.6,
            spaceBetween: 16
          },
          450: {
            slidesPerView: 3,
            spaceBetween: 16
          },
          480: {
            slidesPerView: 3,
            spaceBetween: 16
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 16,
            centeredSlides: false
          }
        }
      });*/
      const articles = new Swiper('.swiper-articles', {
        slidesPerView: 1.2,
        spaceBetween: 12,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          480: {
            slidesPerView: 1.4,
            spaceBetween: 12
          },
          600: {
            slidesPerView: 1.8,
            spaceBetween: 12
          },
          768: {
            slidesPerView: 2.2,
            spaceBetween: 12
          },
          900: {
            slidesPerView: 3,
            spaceBetween: 12
          },
          1280: {
            slidesPerView: 3,
            spaceBetween: 30
          }
        }
      });
      const about_videos = new Swiper('.swiper-about', {
          spaceBetween: 20,
          slidesPerView: 'auto',
          centerInsufficientSlides: true,
          grabCursor: true,
          mousewheel: {
              forceToAxis: true,
              releaseOnEdges: true,
              thresholdDelta: 1,
              thresholdTime: 10
          },
          keyboard: {
              enabled: true,
			  onlyInViewport: true	
          }
      });
      $('.slider-medical').flexslider({
        animation: 'fade',
        animationSpeed: 200,
        directionNav: false,
        slideshowSpeed: 5000,
        controlsContainer: $('.slider-medical-controls'),
        slideshow: true,
        XcontrolNav: false, 
        start: function(slider){
          slider.removeClass('mv-hidden');
        }
      });
      var $flexQuotes = $('.flex-quotes').eq(0);
      $(window).load(function() {
        $flexQuotes.flexslider({
          animation: 'slide',
          animationLoop: false,
          slideshow: false,
          controlNav: ($(window).width() > 770),
          directionNav: false,
          itemWidth: ($(window).width() > 770) ? 578: 312,
          before: function () {
            unshowQuotes3();
          },
          after: function (slider) {
            showQuote3(slider.currentSlide);
          },
          start: function () {
            $('.global-quotes .filter').eq(1).click();
          }
        });
      });
      var $quoteWraps = $flexQuotes.find('.quote-top-wrap');
      function unshowQuotes3() {
        $quoteWraps.removeClass('active');
      }
      function showQuote3(ind) {
        $quoteWraps.eq(ind).addClass('active');
      }
      $('.filter').click(function () {
        var $filters = $('.global-quotes .filter');
        $filters.removeClass('active');
        var $this = $(this);
        $this.addClass('active');
        var itemNumber = parseInt($this.data('goto'), 10);
        $flexQuotes.flexslider(itemNumber - 1);
        return false;
      });
      // $('.swiper-slide').matchHeight();
    }

    swiper();

    // $(window).on('resize', function() {
    //     swiper();
    // });

    var customBanner = $('.announcement');

    customBanner.flexslider({
      animation: 'slide',
      direction: 'vertical',
      controlNav: false,
      directionNav: false,
      animationLoop: true,
      slideshowSpeed: 5000,
      start: function(slider) {
        slider.removeClass('mv-hidden');
      }
    });

    if (!Cookies.get('hide_banner') && !Cookies.get('Xbanner_seen')) {
      if ($('.announcement.flexslider').length > 0) {
        customBanner.show();
        //Cookies.set('banner_seen', 'true', { expires: 1 });
      }
    }
    else {
      customBanner.hide();
    }

    $('.announcement .icon-x').on('click', function () {
      customBanner.hide();
      Cookies.set('hide_banner', 'true', { expires: 1 });
    });

    $('.icons-toggle').on('click', function(e) {
      e.preventDefault();
      var toggle = $(this);
      $('.expandable-icons').slideToggle('300', function() {
        if ($(this).is(':visible')) {
          $('.show-icons').addClass('mv-hidden');
          $('.hide-icons').removeClass('mv-hidden');
        } else {
          $('.show-icons').removeClass('mv-hidden');
          $('.hide-icons').addClass('mv-hidden');
        }
      });
    });

    $('.tooltip').tooltipster({
      theme: 'tooltipster-light'
    });

    $('.accordion-header').on('click', function(e) {
      e.preventDefault();
      $(this).find('span').toggleClass('mv-hidden');
      $(this).next('.accordion-body').slideToggle(300);
    });

    /*$('.product-stars').on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $('.section-experts').offset().top - 50
      }, 300);
    });*/

    $('.faq-link').on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $('.section-faq').offset().top - 100
      }, 300);
    });

    $('.product-hero').flexslider({
      animation: 'fade',
      animationSpeed: 200,
      directionNav: false,
      slideshowSpeed: 8000,
      controlNav: ($(window).width() >= 768) ? 'thumbnails' : true,
      start: function(slider){
         slider.removeClass('mv-hidden');
      }
    });

    $('.product-dot-hero').flexslider({
      animation: "fade",
      animationSpeed: 200,
      directionNav: false,
      slideshowSpeed: 8000,
      controlsContainer: $('.product-default-controls'),
      start: function(slider){
        slider.removeClass('mv-hidden');
      },
      after: function (slider) {
        if ($('.flex-active-slide .slide-hero').length) {
          var active_img = $('.flex-active-slide .slide-hero');
          var desc = active_img.attr('desc');
          $('.hero-desc').hide();
          $('.hero-desc[desc="'+desc+'"]').show();
        }
      }
    });

    if ($(window).width() >= 768) {

      $().fancybox({
        selector: '.slide-hero-link',
        buttons: ['close'],
        thumbs: {
          autoStart: true
        },
        hash: false,
        loop: true,
        infobar: false,
        afterLoad: function (instance, current) {
          $('.fancybox-video').attr({
            muted: true,
            autoplay: true,
            loop: true,
            playsinline: true,
            controls: false
          });
        }
      });

      $().fancybox({
        selector: '.slide-hero-link + .btn-play',
      });

    } else {

      $('.slide-hero-link').on('click', function(e) {
        e.preventDefault();/**/
      });

      $('.slide-hero-link + .btn-play').on('click', function(e) {
        /*e.preventDefault();
        $(this).hide();+
        var vimeoLink = $(this).attr('href');
        var vimeoId = vimeoLink.match(/(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|)(\d+)(?:|\/\?)/);
        var videoTag = '<div class="ratio"><iframe src="https://player.vimeo.com/video/' + vimeoId[4] + '?background=1&autoplay=1&loop=1&byline=0&title=0" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>';
        $(this).prev().find('video').hide();
        $(this).prev().append(videoTag);*/
      });

    }

    function mobile_video() {
      if ($(window).width() < 1024) {
        $('.btn-play').on('click', function(e) {
          /*e.preventDefault();
          $(this).hide();*/
          // wistiaEmbed = document.querySelector('.w-video').wistiaApi;
          // wistiaEmbed.unmute();
          // $video = $(this).closest('iframe');
          // if ( $video.hasClass('wistia_embed') ) {
          //   window._wq = window._wq || [];
          //   $video_id  = /[^/]*$/.exec( $video.attr('src') )[0];
          //   _wq.push({ id: $video_id, onReady: function(video) {
          //     video.play();
          //   }});
          // }
        });
      }
    }

    mobile_video();
  
    $('.fancybox-button--close').on('click', function() {
      $.fancybox.close(true);
    });
  
    $('.product-default-hero').flexslider({
      animation: "fade",
      animationSpeed: 200,
      directionNav: false,
      slideshowSpeed: 8000,
      controlsContainer: $('.product-default-controls'),
      start: function(slider){
        slider.removeClass('mv-hidden');
      },
      after: function (slider) {
        if ($('.flex-active-slide .slide-hero').length) {
          var active_img = $('.flex-active-slide .slide-hero');
          var desc = active_img.attr('desc');
          $('.hero-desc').hide();
          $('.hero-desc[desc="'+desc+'"]').show();
        }
      }
    });
  
    const swiper_logos = new Swiper('.swiper-logos', {
      slidesPerView: 3,
      spaceBetween: 10,
      centeredSlides: true,
      loop: true,
      speed: 600,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false
	  },
      breakpoints: {
        600: {
          slidesPerView: 5
        },
        900: {
          slidesPerView: 6
        }
      },
      navigation: {
        nextEl: '.product-logos-next',
        prevEl: '.product-logos-prev'
      }
    });

    var swiper_logos_quotes = new Swiper('.swiper-logos-quotes', {
      slidesPerView: 1,
      loop: true,
      effect: 'fade',
      navigation: {
        nextEl: '.product-logos-next',
        prevEl: '.product-logos-prev'
      }
    });
  
    swiper_logos.on('slideNextTransitionStart', function () {
      swiper_logos_quotes.slideNext();
    });
  
    swiper_logos.on('slidePrevTransitionStart', function () {
      swiper_logos_quotes.slidePrev();
    });
  
    $(window).on('scroll', function() {
      try {
        var scroll = $(window).scrollTop();
        var bottom = $('.subscribe').position().top;
        if (scroll > 350) {
          $('.blog-header').addClass('b-header-fixed');
        } else {
          $('.blog-header').removeClass('b-header-fixed');
        }
        if (scroll > 50 && scroll < (bottom - 830)) {
          $('.sticky_social').removeClass('mv-hidden');
        } else {
          $('.sticky_social').addClass('mv-hidden');
        }
      } catch (err_widow_scroll_subscribe) {
        console.log("ERROR: "+err_widow_scroll_subscribe.message);
      }
    });
  
    $('.blog-menu-toggle').on('click', function() {
      $('.blog-menu').slideToggle(300);
    });
  
    $('.read-more').on('click', function(e) {
      e.preventDefault();
      $(this).hide();
      $('.read-more-text').show();
    });

    $('.more-link').on('click', function(e) {
      e.preventDefault();
      var $parentObj = $(this).parents('.section-infotext');
      var dots = $parentObj.find(".dots");
      var moreText = $parentObj.find(".show-more");
      var btnText = $(this);
      if (dots.css('display') === "none") {
        dots.css('display', "inline");
        btnText.text("Read more");
        moreText.css('display', "none");
      } else {
        dots.css('display', "none");
        btnText.text("Read less");
        moreText.css('display', "inline");
      }
    });

    /*$('.single-review:gt(23)').hide();
    $('#more-reviews').click(function(e) {
        e.preventDefault();
        $('.single-review:gt(23)').toggle();
        $(this).text($(this).text() == 'SHOW MORE' ? 'SHOW LESS' : 'SHOW MORE');
    });*/

    var input = $('.form .input[type="date"]');
    input.on('focus', function() {
      input.removeClass('input-before');
    });
    input.on('blur', function() {
      input.addClass('input-before');
    });

    $('.accordion-faq h2').on('click', function() {
      if ($(this).next().is(':visible')) {
        $(this).next().hide();
      }
      else {
        $(this).next().show();
      }
    });

    $('.filter-btn').on('click', function() {
      $(this).addClass('active').siblings().removeClass('active');
    });

    $('.scroll-link').on('click', function(e) {
      e.preventDefault();
       try {
           $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 500);
       } catch (errtp) {}
  	});

    $('.card-hover-label').on('mouseover', function(e) {
      $(this).find('.pre-hover-label').hide();    
      $(this).find('.post-hover-label').show();
    });
    $('.card-hover-label').on('mouseout', function(e) {
       $(this).find('.post-hover-label').hide();
       $(this).find('.pre-hover-label').show();
     });

    $('.footer-country-list-open').on('click', function() {
      $('.footer-country-list').addClass('shown').removeClass('hidden');
    });

    $(document).on('click', function(e) {
      if(!$(e.target).hasClass('clist') && !$(e.target).closest('.clist').length) {
        $('.footer-country-list').removeClass('shown').addClass('hidden');
      }
    });


  $(document).on('mouseover', '.product-benefits-hover', function() {
	try { gtag('event', 'hover_item', { 'class': 'product-benefits-hover', 'page': 'product', 'section': 'benefits' }); console.log("hover_item"); } catch (err_hover_ev1) {console.log("ERROR: "+err_hover_ev1.message);}
  });
  $(document).on('mouseover', '.product-contents-hover', function() {
	try { gtag('event', 'hover_item', { 'class': 'product-contents-hover', 'page': 'product', 'section': 'product-contents' }); console.log("hover_item"); } catch (err_hover_ev2) {console.log("ERROR: "+err_hover_ev2.message);}
  });
  $(document).on('mouseover', '.landing-benefits-hover', function() {
	try { gtag('event', 'hover_item', { 'class': 'landing-benefits-hover', 'page': 'landing', 'section': 'benefits' }); console.log("hover_item"); } catch (err_hover_ev3) {console.log("ERROR: "+err_hover_ev3.message);}
  });
  $(document).on('mouseover', '.landing-contents-hover', function() {
	try { gtag('event', 'hover_item', { 'class': 'landing-contents-hover', 'page': 'landing', 'section': 'product-contents' }); console.log("hover_item"); } catch (err_hover_ev4) {console.log("ERROR: "+err_hover_ev4.message);}
  });
  $(document).on('mouseover', '.health-benefits-hover', function() {
	try { gtag('event', 'hover_item', { 'class': 'health-benefits-hover', 'page': 'health', 'section': 'benefits' }); console.log("hover_item"); } catch (err_hover_ev5) {console.log("ERROR: "+err_hover_ev5.message);}
  });
  $(document).on('mouseover', '.press-award-hover', function() {
	try { gtag('event', 'hover_item', { 'class': 'press-award-hover', 'page': 'press', 'section': 'award' }); console.log("hover_item"); } catch (err_hover_ev6) {console.log("ERROR: "+err_hover_ev6.message);}
  });
  $(document).on('mouseover', '.reviews-review-hover', function() {
	try { gtag('event', 'hover_item', { 'class': 'reviews-review-hover', 'page': 'reviews', 'section': 'review' }); console.log("hover_item"); } catch (err_hover_ev7) {console.log("ERROR: "+err_hover_ev7.message);}
  });
  $(document).on('mouseover', '.awards-award-hover', function() {
	try { gtag('event', 'hover_item', { 'class': 'awards-award-hover', 'page': 'reviews', 'section': 'review' }); console.log("hover_item"); } catch (err_hover_ev8) {console.log("ERROR: "+err_hover_ev8.message);}
  });

  
  $(document).on('click', '.dimensionsicon-link a', function() {
	try {
      $('.product-hero ol.flex-control-nav li:last img').click();
    } catch (err_hover_dimensionslink) {console.log("ERROR: "+err_hover_dimensionslink.message);}
  });

  $(document).on('click', '.wave-tech-image', function() {
	try {
      console.log("Click save tech image");
      //$('#image-popup img').attr('src', $('#image-popup img').attr('img'));
      if ($(this).attr('inside')) {
        $('#image-popup img').attr('src', $(this).attr('inside'));
        setTimeout(function() {
          $.fancybox.open([
            {
              src: '#image-popup',
            }
          ]);
        }, 500);
      }
    } catch (err_wave_tech_image) {console.log("ERROR: "+err_wave_tech_image.message);}
  });

  $(document).on('click', '.reviews-popup-trigger', function() {
	try {
      console.log("Click reviews popup");

        setTimeout(function() {
          $.fancybox.open([
            {
              src: '#reviews-popup',
            }
          ]);
        }, 500);
      
    } catch (err_reviews_popup) {console.log("ERROR: "+err_reviews_popup.message);}
  });

  try {
    $('a.card-link').on('mouseenter', function() {
      $(this)
        .data('title', $(this).attr('title'))
        .removeAttr('title')
    }).on('mouseleave', function() {
      $(this).attr('title', $(this).data('title'))
    });
  } catch (err_slide_title_bug) {console.log("ERROR: "+err_slide_title_bug.message);}
  $(document).on('click', 'homepage-preorder-card-img', function() {
    try {
      $(this).closest('.homepage-preorder-card').click();
    } catch (err_slide_bug) {console.log("ERROR: "+err_slide_bug.message);}
  });

  $('.swiper-homepage-banner [data-mh]').matchHeight({ byRow: false });
  $('.swiper-homepage-devices [data-mh="homepage-devices-r1"]').matchHeight({ byRow: false });
  $('.swiper-homepage-devices [data-mh="homepage-devices-r2"]').matchHeight({ byRow: false });
  $('.swiper-homepage-devices [data-mh="homepage-devices-r3"]').matchHeight({ byRow: false });
  
});